import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.taskList.length ? _c('div', {
    staticClass: "component-task-entry",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goTaskDetailsPage.apply(null, arguments);
      }
    }
  }, [_c('ycf-image', {
    staticClass: "limit-time",
    attrs: {
      "src": "/srcv2/images/limit_time_word_20190830.png"
    }
  }), _vm.task.type == 1 ? _c('span', {
    staticClass: "txt-word"
  }, [_vm._v("该产品限时分享中，现金大奖免费拿！")]) : _vm.task.type == 2 ? _c('span', {
    staticClass: "txt-word"
  }, [_vm._v("限时福利,完成分享任务获"), _c('i', [_vm._v(_vm._s(_vm.task.prizeNum))]), _vm._v("元额外奖金")]) : _vm.task.type == 3 ? _c('span', {
    staticClass: "txt-word"
  }, [_vm._v("限时福利，完成拉新任务获超高现金奖励！")]) : _vm.task.type == 4 ? _c('span', {
    staticClass: "txt-word"
  }, [_vm._v("该产品正在参与【" + _vm._s(_vm._f("interceptStr")(_vm.task.name)) + "】")]) : _c('span', {
    staticClass: "txt-word"
  }, [_vm._v("一大波福利来袭，现金、红包奖不停~")]), _c('span', {
    staticClass: "btn-look"
  }, [_vm._v("去看看")])], 1) : _vm._e(), _vm.canShowBox && _vm.unTask.taskId && _vm.unTask.type != 4 ? _c('component-task-box', {
    attrs: {
      "type": "1",
      "task": _vm.unTask
    }
  }) : _vm._e(), _vm.canShowBox && _vm.unTask.taskId && _vm.unTask.type == 4 ? _c('ComponentrewardToolBox', {
    attrs: {
      "task": _vm.unTask
    }
  }) : _vm._e(), _c('component-welfare-task', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.taskList.length > 1,
      expression: "taskList.length>1"
    }],
    attrs: {
      "data": _vm.taskList
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };